import Vue from 'vue';

export default {
  getAuthHeader (context) {
    return `Bearer ${Vue.$storage.get('token')}`;
  },
}
